import { PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

const UpdateLanguagePageHeader = () => {
  const { t } = useTranslation()
  return <PageHeader ghost={false} title={t('components.pages.languages.update.pageHeader.title')} />
}

UpdateLanguagePageHeader.displayName = 'UpdateLanguagePageHeader'
export default UpdateLanguagePageHeader
